import axiosInstance from "./axiosInstance";

export const getProductReviews = async (productId) => {
  const response = await axiosInstance.get(`/reviews/product/${productId}`);
  const data = response.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.reviews)) return data.reviews;
  return [];
};

export const getReviewStats = async (productId) => {
  const response = await axiosInstance.get(`/reviews/stats/${productId}`);
  return response.data;
};

export const createReview = async (reviewData) => {
  const response = await axiosInstance.post("/reviews", reviewData);
  return response.data;
};

export const toggleReviewLike = async (reviewId) => {
  const response = await axiosInstance.post(`/reviews/like/${reviewId}`);
  return response.data;
};
